import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';

import style from './index.module.scss';

function AppModal({
  children,
  closeModal,
  openModal,
  isModalOpen,
  isFooterDisplayed,
  label,
}) {
  return (
    <Modal show={isModalOpen} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>{label}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {isFooterDisplayed && (
        <Modal.Footer>
          <span onClick={closeModal} className={style.close}>
            Close
          </span>
          <Button onClick={closeModal}>{label}</Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

AppModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  isFooterDisplayed: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
};

export default AppModal;
